package eu.bontlab.models

import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.rgb

enum class Theme(
    val hex: String,
    val rgb: CSSColorValue
) {
  //  Primary(hex = "#00A78E", rgb = rgb(r = 0, g = 167, b = 142)),
    Primary(hex = "#E6B800", rgb = rgb(r = 230, g = 184, b = 142)),
    Secondary(hex = "##CC00FF", rgb = rgb(r = 204, g = 0, b = 255)),
    Gray(hex = "#CFCFCF", rgb(r = 207, g = 207, b = 207)),
    LightGray(hex = "#EDEDED", rgb(r = 237, g = 237, b = 237)),
    LighterGray(hex = "#F9F9F9", rgb(r = 249, g = 249, b = 249))
   // Secondary(hex = "#121D34", rgb = rgb(r = 18, g = 29, b = 52)),
}